import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";
import { motion } from "framer-motion";

export default function KontakSekolah() {
  const [kontak, setKontak] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchKontak = async () => {
      try {
        const ref = doc(db, "informasi", "kontakSekolah");
        const snap = await getDoc(ref);
        if (snap.exists()) setKontak(snap.data());
      } catch (error) {
        console.error("Gagal mengambil data kontak:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchKontak();
  }, []);

  /* ================= MAP SRC HANDLER ================= */
  const getMapSrc = () => {
    if (!kontak) return null;

    // 1️⃣ PRIORITAS: embed / link manual
    if (kontak.mapsEmbed) {
      return kontak.mapsEmbed;
    }

    // 2️⃣ GPS lat lng
    if (kontak.mapsLat && kontak.mapsLng) {
      return `https://www.google.com/maps?q=${kontak.mapsLat},${kontak.mapsLng}&z=16&output=embed`;
    }

    return null;
  };

  return (
    <section
      className="py-5 mt-5"
      style={{
        background: "linear-gradient(135deg, #004aad 0%, #1e3c72 100%)",
        color: "white",
      }}
    >
      <div className="container">
        <motion.h2
          className="fw-bold text-center mb-5"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          Kontak & Lokasi Sekolah
        </motion.h2>

        {loading ? (
          <p className="text-center">Memuat informasi kontak...</p>
        ) : !kontak ? (
          <p className="text-center">Belum ada informasi kontak sekolah.</p>
        ) : (
          <div className="row g-4 align-items-stretch">
            {/* ================= INFO ================= */}
            <motion.div
              className="col-md-6"
              initial={{ opacity: 0, x: -40 }}
              animate={{ opacity: 1, x: 0 }}
            >
              <div
                className="h-100 p-4 bg-white text-dark"
                style={{
                  borderRadius: "18px",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
                }}
              >
                <h5 className="fw-bold mb-4" style={{ color: "#004aad" }}>
                  Hubungi Kami
                </h5>

                <div className="mb-3 d-flex">
                  <FaMapMarkerAlt className="text-primary me-3 mt-1" />
                  <div>
                    <div className="fw-semibold">Alamat</div>
                    <div>{kontak.alamat}</div>
                  </div>
                </div>

                <div className="mb-3 d-flex">
                  <FaPhoneAlt className="text-primary me-3 mt-1" />
                  <div>
                    <div className="fw-semibold">Telepon</div>
                    <div>{kontak.telepon}</div>
                  </div>
                </div>

                <div className="mb-4 d-flex">
                  <FaEnvelope className="text-primary me-3 mt-1" />
                  <div>
                    <div className="fw-semibold">Email</div>
                    <div>{kontak.email}</div>
                  </div>
                </div>

                <h6 className="fw-bold">Sosial Media</h6>
                {kontak.instagram && (
                  <p className="mb-2">
                    <FaInstagram className="text-danger me-2" />
                    <a
                      href={kontak.instagram}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Instagram Sekolah
                    </a>
                  </p>
                )}
                {kontak.youtube && (
                  <p>
                    <FaYoutube className="text-danger me-2" />
                    <a
                      href={kontak.youtube}
                      target="_blank"
                      rel="noreferrer"
                    >
                      YouTube Sekolah
                    </a>
                  </p>
                )}
              </div>
            </motion.div>

            {/* ================= MAP ================= */}
            <motion.div
              className="col-md-6"
              initial={{ opacity: 0, x: 40 }}
              animate={{ opacity: 1, x: 0 }}
            >
              <div
                className="h-100"
                style={{
                  borderRadius: "18px",
                  overflow: "hidden",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.25)",
                }}
              >
                {/* IFRAME MANUAL */}
                {kontak.mapsEmbed?.includes("<iframe") ? (
                  <div
                    dangerouslySetInnerHTML={{ __html: kontak.mapsEmbed }}
                    style={{ width: "100%", height: "100%" }}
                  />
                ) : getMapSrc() ? (
                  <iframe
                    src={getMapSrc()}
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    loading="lazy"
                    title="Google Maps"
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                ) : (
                  <p className="text-center mt-4">
                    Belum ada peta lokasi.
                  </p>
                )}
              </div>
            </motion.div>
          </div>
        )}
      </div>

      <div className="text-center mt-5 pt-4 border-top border-light">
        <small>
          © {new Date().getFullYear()} SMP Muhammadiyah 2 Bolang Dayeuhluhur
        </small>
      </div>
    </section>
  );
}
